import { useEffect, useState } from 'react';

/**
 * El alto REAL, medido, de la cabecera del micrositio (`.site-header`).
 *
 * Existía copiado en `CatalogoPage` y `AnimalCatalogoPage` —palabra por
 * palabra, con su propio `useState` y su propio `useEffect`— y `SeccionCatalogoPage`
 * se había quedado afuera, usando sólo el alto TEÓRICO (`altoHeaderDe`). Eso
 * no dolía mientras la cabecera media lo que el tipo de cabecera predice, pero
 * desde que la franja de bienvenida de OP-1 vive DENTRO de la cabecera
 * (`franjaSuperior` de `SiteHeader`), el alto real y el teórico dejan de
 * coincidir: con el teórico solo, el contenido del listado arranca tapado por
 * la franja.
 *
 * `ResizeObserver` y NO una medición única: el alto cambia al rotar el
 * teléfono, al achicar la ventana, cuando termina de cargar el logo, o ahora
 * también cuando la franja de bienvenida entra o sale de la cabecera — y una
 * medición de una sola vez agarra el alto de ANTES de que esos elementos
 * ocupen su lugar.
 *
 * @param {*} listo  Cualquier valor que cambie cuando el DOM ya tenga la
 *                    cabecera para medir — típicamente el `data` de la
 *                    página. La cabecera se monta recién cuando llegó la
 *                    config del catálogo, así que antes de eso no hay nodo.
 * @returns {number}  El alto medido en px, `0` hasta la primera medición.
 */
export function useAltoHeaderMedido(listo) {
  const [alto, setAlto] = useState(0);

  useEffect(() => {
    // `.site-header` y NO `.site-header-desktop`: ese hijo es `display: none`
    // en mobile —ahí manda `.site-header-mobile`— así que medirlo daba 0 y el
    // contenido arrancaba tapado en el teléfono. El padre existe en los dos
    // casos y ya se mide del DOM en el micrositio para anclar el countdown,
    // así que la clase está puesta a propósito y no se va a caer sin que
    // alguien lo note.
    const nodo = document.querySelector('.site-header');
    if (!nodo) return undefined;
    const medir = () => setAlto(nodo.offsetHeight || 0);
    medir();
    const observador = new ResizeObserver(medir);
    observador.observe(nodo);
    return () => observador.disconnect();
  }, [listo]);

  return alto;
}
